function checkAndSelectVariantRadio() {
  const currentURL = window.location.href;
  if (!currentURL.includes('products')) return;

  const variantTitle = localStorage.getItem('variant_title');
  if (!variantTitle) return;

  const matchingInputs = document.querySelectorAll(
    `input[type="radio"][data-variant-value="${variantTitle}"]`
  );

  // Exit if no matches found
  if (!matchingInputs.length) return;

  // [Archies 2026-10-05] Uncheck ONLY within each match's own fieldset.
  //
  // This used to blank every radio on the page and then re-check just the matches. That was safe
  // while a product had one option (size): the stored variant_title matched the size radio, so it
  // was immediately re-checked. Once the combined listing went live Shopify added the parent's
  // style option to every child, so the picker now has a SECOND, hidden fieldset whose radio value
  // is the colour ("Blue"). variant_title never matches it, so the blanket uncheck left that
  // fieldset with nothing checked — and VariantRadios.updateOptions() does
  //     fieldset.querySelectorAll("input").find(r => r.checked).value
  // with no guard, so it threw "Cannot read properties of undefined (reading 'value')".
  // That throw happens inside the VariantSelects constructor, on the line BEFORE
  // addEventListener('click', ...), so the picker never got a click handler: the Add to Cart
  // button stayed on "Please Select Size" forever and clicking a size did nothing.
  // Incognito was unaffected only because there is no stored variant_title to restore.
  //
  // product-variant-tabs.liquid states the invariant this restores: "The combined-listing (style)
  // option has to stay in the DOM and stay checked."
  matchingInputs.forEach((input) => {
    const scope = input.closest('fieldset');
    if (scope) {
      scope.querySelectorAll('input[type="radio"]').forEach((r) => {
        r.checked = false;
      });
    }
    input.checked = true;
  });
}

checkAndSelectVariantRadio();
